






























import {
  computed, defineComponent, inject, PropType,
} from '@nuxtjs/composition-api';
import { SfScrollable, SfHeading } from '@storefront-ui/vue';
import Checkbox from './Checkbox.vue';
import type { Aggregation } from '~/modules/GraphQL/types';

export default defineComponent({
  components: {
    Checkbox,
    SfScrollable,
    SfHeading,
  },
  props: {
    filter: {
      type: Object as PropType<Aggregation>,
      required: true,
    },
  },
  methods: {
    getClassLabel(label) {
      const sanitizeString = label?.toLowerCase().replace('à','a').replace(/[^a-zA-Z ]/g, "").replace(/\s+/g, "-") ?? '';
      return sanitizeString;
    }
  },
  setup() {
    const { isFilterSelected } = inject('UseFiltersProvider') as any;
    const selected = computed(() => ((id: string, optVal: string) => isFilterSelected(id, optVal)));
    return { selected };
  },
});
